import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TicketService } from '../../shared/services/ticket.service';
import { Ticket, TicketDetail, TicketSupply } from '../../shared/models/ticket-model/tiket.model';
import { LocationDetailResponse } from '../../shared/models/location-model/location.model';
import { GeneralService } from '../../shared/services/general.service';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { ExpancionCard } from '../../shared/components-generals/expancion-card/expancion-card';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Product } from '../../shared/models/products-model/products.model';
import { MatButtonModule } from '@angular/material/button';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';

@Component({
  selector: 'app-delivered-model',
  imports: [MatIcon, MatIconModule, ExpancionCard, NgClass, MatButtonModule, LoadGeneralComponent],
  templateUrl: './delivered-model.html',
  styleUrl: './delivered-model.css',
})
export class DeliveredModel {
  private breakpointSubscription!: Subscription;
  private closedTicketPage = 1;
  private closedTicketPageSize = 10;
  private closedTicketTotalCount = 0;
  public ticketPendingSupply: TicketSupply[][] = [];
  public closeTicketDetail: { [key: string]: TicketDetail[] } = {};
  public isLoading = true;
  public mobile = false;

  constructor(
    public dialog: MatDialog,
    public ticketService: TicketService,
    private generalService: GeneralService,
    private breakpointObserver: BreakpointObserver,
    public dialogRef: MatDialogRef<DeliveredModel>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      ticketDetail: TicketDetail;
      locationDetail: LocationDetailResponse;
      ticketInProcess: string;
    },
  ) {
    this.checkScreenSize();
  }

  ngOnInit(): void {
    this.getClosedTicket({
      Page: this.closedTicketPage,
      PageSize: this.closedTicketPageSize,
      SearchField: 'LocationKey',
      SearchFieldValue: this.data.locationDetail?.Key || '',
    });
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  public getClosedTicket(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
  }): void {
    this.isLoading = true;
    this.ticketService.getClosedTicket(params).subscribe((response) => {
      this.closedTicketTotalCount = response?.Data.TotalCount || 0;

      const solicitudHelado: Ticket[] =
        response?.Data.Items.filter((item) => item.WorkFlowType === 'Solicitud Helado') || [];
      if (solicitudHelado?.length) {
        const services = solicitudHelado.map((item) => {
          return this.ticketService.getTicketDetail(item.Id);
        });

        this.generalService.getServices(services).then((ticketDetail) => {
          ticketDetail.forEach((element) => {
            if (element?.Data && this.data.ticketInProcess !== element.Data.Key) {
              if (!this.closeTicketDetail[element.Data.Key]) {
                this.closeTicketDetail[element.Data.Key] = [];
              }
              this.closeTicketDetail[element.Data.Key].push(element.Data);
            }
          });

          const servicesSupply = Object.values(this.closeTicketDetail).map((item) => {
            return this.ticketService.ticketPendingSupply(item[0].Id);
          });

          this.generalService.getServices(servicesSupply).then((supplys) => {
            supplys.forEach((supply) => {
              this.ticketPendingSupply.push(supply!.Data || []);
            });

            this.isLoading = false;
          });
        });
      } else {
        this.isLoading = false;
      }
    });
  }

  public onScrollClosedTickets(event: Event): void {
    const element = event.target as HTMLElement;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
    if (!atBottom || this.isLoading) return;

    const totalPages = Math.ceil(this.closedTicketTotalCount / this.closedTicketPageSize);
    if (this.closedTicketPage >= totalPages) return;

    this.closedTicketPage++;
    this.getClosedTicket({
      Page: this.closedTicketPage,
      PageSize: this.closedTicketPageSize,
      SearchField: 'LocationKey',
      SearchFieldValue: this.data.locationDetail?.Key || '',
    });
  }

  public getcloseTicketDetailList(): TicketDetail[][] {
    console.log('Detalle de tickets cerrados:', this.closeTicketDetail);
    return Object.values(this.closeTicketDetail);
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  public getproductInCarList(): Product[] {
    return [];
  }
}
